<template>
  <div class="container-fluid mt-2">
    <div class="row">
      <div class="col-md">
        <b-table @row-clicked="selectEvent" striped hover :items="events" :fields="fields">
        </b-table>
      </div>
      <div class="col-md">
        <div class="btn-toolbar d-flex justify-content-between">
          <button @click="saveEvent" class="btn btn-primary ml-2"><font-awesome-icon icon="save"/>&nbsp;Speichern</button>
          <button @click="addEvent" class="btn btn-primary"><font-awesome-icon icon="plus"/>&nbsp;Hinzufügen</button>
          <button @click="deleteEvent" class="btn btn-danger ml-2"><font-awesome-icon icon="trash"/>&nbsp;Löschen</button>
        </div>
        <div class="form-group mt-3">
          <label>Name</label>
          <input type="text" class="form-control" v-model="selected.name"/>
        </div>
        <div class="form-group">
          <label>Group ID</label>
          <input type="text" class="form-control" v-model="selected.group"/>
        </div>
        <div class="form-group">
          <label>Event ID</label>
          <input type="text" class="form-control" v-model="selected.event"/>
        </div>
        <UserEventManager :data="selected" v-if="type == 'user'"></UserEventManager>
        <div class="wrapper" v-if="type == 'time'">
          <CronExprBuilder ref="cronEditor" :icron="selected.config.cron"/>
        </div>
        <div class="wrapper" v-if="type == 'webhook'">
          <div class="card p-2">
            <h5>Test Kommando</h5>
            <div class="form-group">
              <label>Hostname</label>
              <input type="text" class="form-control" v-model="testhost"/>
            </div>
            <div class="form-group">
              <label>API-Key</label>
              <input type="text" class="form-control" v-model="testkey"/>
            </div>
            <div class="form-group">
              <label>CURL:</label>
              <small class="form-text">curl -k -H "Content-Type: application/json" -H "X-API-Key: {{ testkey }}" -X POST -d "{test:123}" https://{{ testhost }}/webhooks/{{ selected.group }}/{{ selected.event }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bflows from '@/modules/bflows.js'
import CronExprBuilder from '@/components/CronExprBuilder.vue'
import UserEventManager from '@/components/digitalfirm/events/UserEventManager.vue'


export default {
  name: 'BaseEventManager',
  props: {
    type: { type: String, required: true }
  },
  components: {
    CronExprBuilder,
    UserEventManager
  },
  data() {
    return {
      testhost: 'localhost:10445',
      testkey: 'mysecretkey',
      events: [],
      selected: { config: {} , type: this.type },
      fields: [
        { label: 'ID', key: 'id' },
        { label: 'Name', key: 'name' },
        { label: 'Group', key: 'group' },
        { label: 'Event', key: 'event' }
      ],
    }
  },
  created: function() {
    this.fetchData();
  },
  methods: {
    selectEvent(evt) {
      this.selected = evt;
      console.log(evt);
      if (this.selected.type == 'time' && this.selected.config && this.selected.config.cron) {
        console.log('set cron: ' + this.selected.config.cron);
        this.$refs.cronEditor.cron = this.selected.config.cron;
      }
    },
    saveEvent() {
      console.log(JSON.stringify(this.selected));
      if (!this.selected ||
        !this.selected.name || this.selected.name == '' ||
        !this.selected.event || this.selected.event == '' ||
        !this.selected.group || this.selected.group == '') {

        this.$bvToast.toast('Bitte erst einen Namen, Gruppe und Event ID eingeben.',{title: 'Events',variant: 'warning'});
        return;
      }
      var self = this;
      this.selected.type = this.type;
      if (this.type == 'time') {
        this.selected.config = this.selected.config || {};
        this.selected.config.cron = this.$refs.cronEditor.cron;
        console.log('timer event ' + this.selected.config.cron);
      }

      bflows.savebaseevent(this,this.selected,function(data) {
        self.selected = data;
        self.fetchData();
        self.$bvToast.toast('Event wurde aktualisiert.',{title: 'Events', variant: 'success'});
      })
    },
    addEvent() {
      this.selected = { type: this.type, config: {} };
    },
    deleteEvent() {
      if (!this.selected || !this.selected.id) return;
      var self = this;
      bflows.deletebaseevent(this,this.selected.id,function(data) {
        console.log(data);
        self.fetchData();
        self.addEvent();
      })
    },
    fetchData() {
      var self = this;
      bflows.listbaseevents(this,this.type,function(data) {
        self.events = data;
      })
    }
  }
}
</script>
